"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.user = void 0;
var user = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1399q0 109-62.5 187t-150.5 78h-854q-88 0-150.5-78t-62.5-187q0-85 8.5-160.5t31.5-152 58.5-131 94-89 134.5-34.5q131 128 313 128t313-128q76 0 134.5 34.5t94 89 58.5 131 31.5 152 8.5 160.5zM1024 512q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5z"
    }
  }]
};
exports.user = user;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/fa/user.js
// module id = 1096
// module chunks = 0